// utility sanitize version: null
import materials, { defaultSwatch } from '../../data/materials';
import { Kite, Part, Store as MKCStore } from '../types';

export function convertParts(nextKites: MKCStore['kites']): MKCStore['kites'] {
    return Object.entries(nextKites).reduce(
        (sanitizedKites: MKCStore['kites'], [key, dirtyKite]) => {
            const {
                // @ts-ignore
                panels,
                // @ts-ignore
                enforcements,
                // @ts-ignore
                leadingEdges,
                // @ts-ignore
                rods,
                // @ts-ignore
                standoffs,
                // @ts-ignore
                swatches,
                ...kite
            } = dirtyKite;

            const tempKite = {
                ...kite,
                parts: [
                    ...(panels
                        ? panels.map((item) => ({
                              ...item,
                              type: 'panel',
                          }))
                        : []),
                    ...(enforcements
                        ? enforcements.map((item) => ({
                              ...item,
                              type: 'enforcment',
                          }))
                        : []),
                    ...(leadingEdges
                        ? enforcements.map((item) => ({
                              ...item,
                              type: 'leadingEdge',
                          }))
                        : []),
                    ...(rods
                        ? rods.map((item) => ({
                              ...item,
                              type: 'rod',
                          }))
                        : []),
                    ...(standoffs
                        ? standoffs.map((item) => ({
                              ...item,
                              type: 'standoff',
                          }))
                        : []),
                ],
            };

            const partIds = [];
            return {
                ...sanitizedKites,
                [key]: {
                    ...tempKite,
                    parts: tempKite.parts.reduce((reduced: Part[], part) => {
                        if (partIds.includes(part.id)) {
                            return reduced;
                        }
                        partIds.push(part.id);
                        // @ts-ignore
                        if (part.element) delete part.element;
                        return [...reduced, part];
                    }, []),
                },
            };
        },
        {}
    );
}

// utility sanitize version 2 --> 3 // color out, swatches in (for kite parts)
export function convertColorToSwatch(kite: Kite): Kite {
    return {
        ...kite,
        parts: kite.parts
            ? kite.parts.map((part) => {
                  if (part && part.color) {
                      // icarex was the only palette available before v3
                      return {
                          ...part,
                          swatch:
                              materials.icarexPc31.swatches.find(
                                  ({ value }) => value === part.color
                              ) || defaultSwatch,
                      };
                  }
                  return part;
              })
            : [],
    };
}
export function sanitizeV2ToV3(store: MKCStore): MKCStore {
    if (store.meta.version >= 3) return store;
    console.info('MCK Store: v.2 color out, swatches in');

    return {
        ...store,
        meta: {
            ...store.meta,
            version: 3,
        },
        kites: Object.entries(store.kites).reduce(
            (sanitizedKites: MKCStore['kites'], [uuid, kite]) => {
                return {
                    ...sanitizedKites,
                    [uuid]: convertColorToSwatch(kite),
                };
            },
            {}
        ),
    };
}

// v4 every kite has a meta property
export function sanitizeV3ToV4(store: MKCStore): MKCStore {
    if (store.meta.version >= 4) return store;
    console.info('MCK Store: v.3 every kite has meta');

    return {
        ...store,
        meta: {
            ...store.meta,
            version: 4,
        },
        kites: Object.entries(store.kites).reduce(
            (sanitizedKites: MKCStore['kites'], [uuid, kite]) => {
                return {
                    ...sanitizedKites,
                    [uuid]: { ...kite, meta: { notes: '' } },
                };
            },
            {}
        ),
    };
}
